"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctCriterionSchema = exports.CV_SCAN_MESSAGE = exports.CRITERION_MARK_LABELS = exports.CRITERION_MARK_SYMBOLS = exports.RANK_TAB_LABELS = exports.RANKING_EXCLUDED_STAGES = void 0;
exports.cvTextOf = cvTextOf;
exports.rankingCounts = rankingCounts;
const zod_1 = require("zod");
const imports_1 = require("./imports");
const stage_bar_1 = require("./stage-bar");
// R5 — RNK-01 and RNK-02 (F23.02–F23.05). The rules are `atsRank` in match-score.ts; this
// file holds what the API and the screens exchange.
/**
 * Who RNK-01 lists: everyone live on the job (DECISIONS-LOG "Start R5" Q4) except those who
 * left the flow: the Out list (§L33), the auto-rejected list (S15) and transfers.
 */
exports.RANKING_EXCLUDED_STAGES = [...stage_bar_1.OUT_STAGES, 'auto_rejected', 'transferred'];
exports.RANK_TAB_LABELS = {
    top_fit: 'Top fit',
    maybe: 'Maybe',
    low_fit: 'Low fit',
    needs_a_look: 'Needs a look',
};
exports.CRITERION_MARK_SYMBOLS = {
    met: '✓',
    partly: '◐',
    not_met: '✗',
    missing: '?',
};
exports.CRITERION_MARK_LABELS = {
    met: 'Met',
    partly: 'Partly',
    not_met: 'Not met',
    missing: 'Missing',
};
/** §L26 "CV is a scan". */
exports.CV_SCAN_MESSAGE = "This CV is a scanned image, so its text couldn't be read. Open it and set the criteria by hand.";
/**
 * The CV the ranking reads, from its document, or while it's still downloading from the
 * import row: queued, or a timed-out link whose one automatic retry is still to come (§L29).
 */
function cvTextOf(document, importCv) {
    if (document) {
        switch (document.textStatus) {
            case 'ready':
                return { status: 'ready', text: document.extractedText ?? '' };
            case 'pending':
                return { status: 'coming' };
            case 'unreadable':
                return { status: 'unreadable' };
            case 'none':
            case null:
                return { status: 'none' };
        }
    }
    if (!importCv)
        return { status: 'none' };
    const isRetrying = importCv.status === 'problem' && importCv.problem === 'timed_out' && importCv.attempts <= imports_1.CV_AUTO_RETRIES;
    return importCv.status === 'queued' || isRetrying ? { status: 'coming' } : { status: 'none' };
}
const NOTE_MAX = 500;
/** F23.05: ✓ or ✗ with an optional note; null takes a person's mark away (Undo). */
exports.correctCriterionSchema = zod_1.z.object({
    mark: zod_1.z.enum(['met', 'not_met']).nullable(),
    note: zod_1.z.string().trim().max(NOTE_MAX, `At most ${NOTE_MAX} characters.`).nullable().default(null),
    version: zod_1.z.number().int().positive(),
});
/** The tab a row sits in, for counting; a row not yet ranked counts nowhere. */
function rankingCounts(rows) {
    const counts = { top_fit: 0, maybe: 0, low_fit: 0, needs_a_look: 0 };
    for (const row of rows)
        if (row.tab)
            counts[row.tab] += 1;
    return counts;
}
//# sourceMappingURL=ranking.js.map